import React from "react"
import styles from "./button-video.module.css"

export default function ErrorMessage({ title, url }) {
  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <h3 className={styles.videoTitle}>{title}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="text-center mb-4">
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className={`${styles.buttonSeeVideo}`}
            >
              ▶ &nbsp;YouTube Video
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
